import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { ContractBalance } from '@/types/billing'

type ApiResponse<T> = { message?: string; data?: T }

function unwrapResource<T>(raw: ApiResponse<T> | T): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as ApiResponse<T>).data as T
  }
  return raw as T
}

export const contractBalanceApi = {
  get: async (contractId: number): Promise<ContractBalance> => {
    const response = await apiClient.get<ApiResponse<ContractBalance>>(
      API_ENDPOINTS.CONTRACTS.BALANCE(contractId)
    )
    return unwrapResource(response.data)
  },

  updateSettings: async (
    contractId: number,
    settings: { payment_notifications_enabled: boolean }
  ): Promise<ContractBalance> => {
    const response = await apiClient.patch<ApiResponse<ContractBalance>>(
      API_ENDPOINTS.CONTRACTS.BILLING_SETTINGS(contractId),
      settings
    )
    return unwrapResource(response.data)
  },
}
